/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { CreateDocumentDataToJSON, DocumentFromJSON, DocumentEntityActionsRepresentationFromJSON, DuplicateDocumentDataToJSON, UpdateDocumentDataToJSON, } from '../models';
/**
 *
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete document
     */
    DocumentsApi.prototype._deleteRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
                            throw new runtime.RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling _delete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/documents/{documentId}".replace("{".concat('documentId', "}"), encodeURIComponent(String(requestParameters.documentId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete document
     */
    DocumentsApi.prototype._delete = function (documentId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._deleteRaw({ documentId: documentId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all document actions
     */
    DocumentsApi.prototype.actionsRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/documents/entityActions",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(DocumentEntityActionsRepresentationFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Get all document actions
     */
    DocumentsApi.prototype.actions = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionsRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create document
     */
    DocumentsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createDocumentData === null || requestParameters.createDocumentData === undefined) {
                            throw new runtime.RequiredError('createDocumentData', 'Required parameter requestParameters.createDocumentData was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/documents",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateDocumentDataToJSON(requestParameters.createDocumentData),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DocumentFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create document
     */
    DocumentsApi.prototype.create = function (createDocumentData) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createDocumentData: createDocumentData })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Duplicate document
     */
    DocumentsApi.prototype.duplicateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.duplicateDocumentData === null || requestParameters.duplicateDocumentData === undefined) {
                            throw new runtime.RequiredError('duplicateDocumentData', 'Required parameter requestParameters.duplicateDocumentData was null or undefined when calling duplicate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/documents/duplicate",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: DuplicateDocumentDataToJSON(requestParameters.duplicateDocumentData),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Duplicate document
     */
    DocumentsApi.prototype.duplicate = function (duplicateDocumentData) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.duplicateRaw({ duplicateDocumentData: duplicateDocumentData })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch document by id
     */
    DocumentsApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
                            throw new runtime.RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/documents/{documentId}".replace("{".concat('documentId', "}"), encodeURIComponent(String(requestParameters.documentId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DocumentFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch document by id
     */
    DocumentsApi.prototype.get = function (documentId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ documentId: documentId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all documents
     */
    DocumentsApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/documents",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(DocumentFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all documents
     */
    DocumentsApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update document
     */
    DocumentsApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
                            throw new runtime.RequiredError('documentId', 'Required parameter requestParameters.documentId was null or undefined when calling update.');
                        }
                        if (requestParameters.updateDocumentData === null || requestParameters.updateDocumentData === undefined) {
                            throw new runtime.RequiredError('updateDocumentData', 'Required parameter requestParameters.updateDocumentData was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/documents/{documentId}".replace("{".concat('documentId', "}"), encodeURIComponent(String(requestParameters.documentId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateDocumentDataToJSON(requestParameters.updateDocumentData),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update document
     */
    DocumentsApi.prototype.update = function (documentId, updateDocumentData) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({ documentId: documentId, updateDocumentData: updateDocumentData })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DocumentsApi;
}(runtime.BaseAPI));
export { DocumentsApi };
